export default "__VITE_ASSET__ryZFMq15kn5ixB$lOcLxuA__"